<template>
  <div
    class="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-bg-slate-50"
  >
    <div class="tw-fixed tw-left-0 tw-top-0 tw-w-full tw-p-4">
      <img class="tw-w-56" src="/images/logo.svg" alt="Workflow" />
    </div>
    <div class="tw-w-full tw-max-w-2xl">
      <slot />
    </div>
  </div>
</template>
